const state = {

}
const mutations = {
  
}
const actions = {
  // eslint-disable-next-line no-unused-vars
  async toID({ commit }, title) {
    const isMobile = window.innerWidth  <= 768 
    const offset = isMobile ? 53 : 83
    const el = document.getElementById(title)
      const elRect = el.getBoundingClientRect()
          const offsetX = elRect.left + window.scrollX 
          const offsetY = elRect.top + window.scrollY - offset
          console.log(offsetX, offsetY) // 此时应该可以获取到正确的值

          window.scrollTo({
            left: offsetX,
            top: offsetY,
            behavior: 'smooth',
          })
  },
}
const getters = {}
export default {
  state,
  mutations,
  actions,
  getters,
}
